import React from 'react';
import Image from 'next/legacy/image';
import Link from 'next/link';

import { BlogWithoutId, BlogsResponse } from 'apolloClient/types/Blog';
import { defaultImage } from 'src/constants/constants';
import { getSmallImageUrlFromImage, getThumbnailImageUrlFromImage } from 'lib/getImages';
import {
  flattenStrapiBulkDataItems,
  flattenStrapiDataItem,
} from 'lib/flattenStrapiBulkDataItems';
import arrowDown from '../../public/images/arrow-down.svg';
import { StrapiResponseData } from 'apolloClient/types';

const PopularArticles: React.FC<{
  articles?: Array<StrapiResponseData<BlogWithoutId>>;
}> = ({ articles }) => {
  return (
    <div className="mt-20 lg:mt-[-14px] lg:pl-[24px]">
      <button className="flex items-center py-4 pb-[40px] lg:pb-[16px] text-24-32-0.3 uppercase w-max font-sohneBreitBuch">
        <div className="block w-8 mr-1 md:hidden">
          <Image src={arrowDown} alt="popular articles" />
        </div>
        <h2 className="whitespace-nowrap">Popular articles</h2>
      </button>
      <div className="grid grid-cols-2 gap-x-[32px] md:grid-cols-3 lg:grid-cols-1">
        {flattenStrapiBulkDataItems(articles).map(
          ({ slug, title, mainImage }) => {
            const image = flattenStrapiDataItem(mainImage?.data);

            return (
              <Link
                key={slug}
                href={`/blog/${slug}`}
                className="xl:py-6 xl:border-b border-beige-dark md:mb-4 xl:mb-0 group image-wrapper w-[147px] md:w-[205px] lg:w-[375px]"
                passHref
              >
                <div className="xl:flex">
                  <div className="border-transparent">
                    <div className="relative h-[103px] w-[147px] md:h-[144px] md:w-[205px] lg:h-[80px] lg:w-[114px]">
                      <Image
                        className="object-cover w-full h-full"
                        src={
                          getSmallImageUrlFromImage(image) || defaultImage
                        }
                        alt={title}
                        loading="eager"
                        layout="fill"
                        blurDataURL={
                          getThumbnailImageUrlFromImage(image) || defaultImage
                        }
                        placeholder="blur"
                      />
                    </div>
                  </div>
                  <p className="mt-[20px] md:mt-[27px] lg:mt-0 lg:ml-[23px] mb-[53px] lg:mb-0 text-18-23-0.3 font-sohneKraftig group-hover:text-gold-hover">
                    {title}
                  </p>
                </div>
              </Link>
            );
          }
        )}
      </div>
    </div>
  );
};

export default PopularArticles;
